// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".st2[data-v-55a19296] {\n  fill: #a1e7fc;\n}\n.st11[data-v-55a19296] {\n  fill: none;\n  stroke: #23286b;\n  stroke-linecap: round;\n  stroke-miterlimit: 10;\n}\n.st12[data-v-55a19296] {\n  fill: #ffbeb6;\n}\n.st13[data-v-55a19296] {\n  fill: #1A7BEE;\n}\n.st15[data-v-55a19296] {\n  fill: #23286b;\n}\n.st20[data-v-55a19296] {\n  fill: #d62929;\n}\n", ""]);
// Exports
module.exports = exports;
